import React from "react";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import Title from "../../../pages/Login/Components/title/title";
import BarraSupDent from "../../../commons/BarraSupDent";
import firebaseManager from "../../../model/Firebase/FirebaseManager";
import PhotoAfterRepair from "./Components/PhotoAfterRepair";

class Job_completed extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super(props);
    this.showDentInProgress = this.showDentInProgress.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      car_model: "",
      car_brand: "",
      dent_place: "",
      info_location: "",
      price: "",
      timeSelectedRepair: "",
      img1: "",
      img2: "",
      img3: "",
      imgAfterRepair: "",
      notes: "",
    };
    this.showDentInProgress();
  }

  showDentInProgress() {
    firebaseManager.dentInProgress(this.successShowDentInProgress);
  }

  successShowDentInProgress = (dataDent) => {
    this.setState({
      car_model: dataDent.car_model,
      car_brand: dataDent.car_brand,
      info_location: dataDent.info_location,
      dent_place: dataDent.dent_place,
      price: dataDent.price,
      timeSelectedRepair: dataDent.SelectedTimeRepair,
      img1: dataDent.img1,
      img2: dataDent.img2,
      img3: dataDent.img3,
      imgAfterRepair: dataDent.imgAfterRepair,
      notes: dataDent.notes,
    });
  };

  handleClick (e) {
      e.preventDefault()
      if (!this.state.imgAfterRepair) {
        alert('Please upload a photo of the work done.')
      } else {
      firebaseManager.completeJob(this.successJobComplete, this.failJobComplete)
    }
  }

  successJobComplete = () => {
        window.location="/homeTechnician"
  }

  failJobComplete (error) {
      console.log(error.message)
  }
  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <b>
          <Title text1="COMPLETE" />
        </b>
      
        <div className="mx-auto mt-3 mb-3 contenedor-request">
          <div className="mx-auto mt-3 mb-3">
          <div className="container card-request mt-3 mb-3">
          
              <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>REPAIR PRICE:</td>
                  <td>{
                  this.state.price ||
                    "Price to be confirmed"
                  }</td>
                </tr>
                <tr>
                  
                  <td>VEHICLE:</td>
                  <td>{this.state.car_brand}</td>
                 
                </tr>
                <tr>
                
                  <td>MODEL:</td>
                  <td>{this.state.car_model}</td>
                </tr>
                <tr>                          
                <td>DENT LOCATION:</td>
                <td>{this.state.dent_place}</td>
              </tr>
              <tr>                          
                <td>ADDRESS:</td>
                <td>{this.state.info_location}</td>
              </tr>
              <tr>                          
                <td>TIME AVAILABLE:</td>
                <td>{this.state.timeSelectedRepair}</td>
              </tr>
              </tbody>
            </table>
        
          <div className="text-center mt-4 pb-4">
              <div className="row justify-content-between ml-3 mr-3">
                  <div className="col-xs-4 mb-1">
                  <img width="90px" height="90px" src={
                    this.state.img1
                  } alt="imagen" className="mx-auto"/>
                  </div>
                  <div className="col-xs-4 mb-1">
                      <img width="90px" height="90px" src={
                    this.state.img2
                  } alt="imagen" className="mx-auto"/>
                  </div>
                  <div className="col-xs-4 mb-1">
                      <img width="90px" height="90px" src={
                    this.state.img3
                  } alt="imagen" className="mx-auto" />
                  </div>
              </div>
          </div>
          <div className="row pb-3 pt-3">
          <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>NOTES:</td>
                  <td>{
                  this.state.notes ||
                    "No notes"
                  }</td>
                </tr>
              </tbody>
            </table>
        
            </div>
            <table className="table table-borderless">
              <tbody>
              <tr>                          
                <td>PHOTO AFTER REPAIR:</td>
                <td><PhotoAfterRepair urlPhoto={this.state.imgAfterRepair} /></td>
              </tr>
              </tbody>
            </table>
          </div>
          </div>
          </div>
        <div className="text-center mb-5">
          <div className="text-center mt-4">
            <button
              id="buttonPhotoAfterRepair"
              className="btn btn-secondary mx-auto mb-5"
              onClick={this.handleClick}
            >
              Complete job
            </button>
          </div>
        </div>
        <NavbarTechnician />
      </React.Fragment>
    );
  }
}
export default Job_completed;
